// Steps: Actions triggered for each step/next button within the application.
import { Dispatch } from 'redux';

import { AppState } from '../../reducers';
import { trackEvent, TrackingStep } from '../../util/piwik-utils';
import { updateApplication } from '../application';
import { formCompletionLoanDetails, FormTypeCompletionDetails } from '../forms';
import { fetchKycStatus } from '../kyc';
import { AppActions } from '../types';
import { openStep } from './steps';

/* Step 1 - Loan Details */
export const loanCompletionDetailsNextEvent =
    (form: FormTypeCompletionDetails) => async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
        trackEvent(TrackingStep.CompletionDetails);
        dispatch(formCompletionLoanDetails(form));
        await fetchKycStatus(dispatch, getState, true);
        dispatch(openStep(5));
    };

/* Step 2 - KYC */
export const updateApplicationKycNextEvent = () => async (dispatch: Dispatch<AppActions>, getState: () => AppState) => {
    await updateApplication(dispatch, getState);
};
